export default __webpack_public_path__ + "static/media/orgs_level.d5bafeda.svg";